<template>
  <div class="app-operations-layout pa-3">
    <div class="app-operations-layout-list">
      <TripAndDriverList
        @selectedTripChanged="selectedTripChanged"
        :filters="tripListFilter"
        :selectedTripId="selectedTripId"
      />
    </div>
    <div class="app-operations-layout-detail d-flex flex-column pl-3">
      <v-card elevation="0" class="py-2 rounded-lg">
        <v-row no-gutters>
          <!-- <v-col
            cols="3"
            class="d-flex justify-start align-center pl-2"
            v-if="isCurrentTabsVisible"
          >
            <SelectField
              v-model="selectedProject"
              dense
              outlined
              label="Select Project"
              :itemsList="projectList"
              itemText="name"
              itemValue="id"
              @change="onProjectChange()"
            />
          </v-col> -->
          <v-col cols="4" class="d-flex justify-start align-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  icon
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  @click="previousDay()"
                  class="mr-2"
                >
                  <v-icon dense> mdi-arrow-left-drop-circle </v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">previous day </span>
            </v-tooltip>

            <DatePicker
              type="date"
              label="Select Date"
              dense
              outlined
              hide-details="auto"
              class="pa-0 ma-0"
              v-model="date"
              :max="nowDate"
            />

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="isCurrentTabsVisible"
                  color="primary"
                  icon
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  @click="nextDay"
                  class="ml-2"
                >
                  <v-icon dense> mdi-arrow-right-drop-circle </v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">next day </span>
            </v-tooltip>
            <PrimaryButton
              v-show="nowDate != date"
              name="Today"
              small
              btnClass="ml-2 rounded-lg"
              @click="onSetToday"
            />
          </v-col>
          <v-col cols="4"></v-col>
          <!-- <v-col cols="3" v-if="!isCurrentTabsVisible"></v-col> -->
          <v-col cols="4" class="d-flex justify-end">
            <v-btn-toggle
              id="operationalAnalyticsToggle"
              v-if="selectedTripId"
              v-model="tripTab"
              dense
              mandatory
              tile
              color="primary"
              group
            >
              <v-btn id="operationalAnalyticsMap">
                <v-icon color="primary" class="mr-2" dense> mdi-map </v-icon>
                <h5>Map</h5>
              </v-btn>

              <v-btn id="operationalAnalyticsOrder" class="mr-2">
                <v-icon color="primary" class="mr-2" dense>mdi-table</v-icon>
                <h5>{{ orderModule.orderPlural }}</h5>
              </v-btn>
            </v-btn-toggle>

            <v-btn-toggle
              id="operationalAnalyticsToggle"
              v-else
              v-model="operationTab"
              dense
              mandatory
              tile
              color="primary"
              group
            >
              <v-btn id="operationalAnalyticsMap" v-show="isCurrentTabsVisible">
                <v-icon color="primary" class="mr-2" dense> mdi-map </v-icon>
                <h5>Map</h5>
              </v-btn>

              <v-btn id="operationalAnalyticsSummary">
                <v-icon color="primary" class="mr-2" dense>
                  mdi-chart-bar-stacked
                </v-icon>
                <h5>Summary</h5>
              </v-btn>

              <v-btn id="operationalAnalyticsTable">
                <v-icon color="primary" class="mr-2" dense>mdi-table</v-icon>
                <h5>Table</h5>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        elevation="0"
        class="background_color"
        style="height: calc(100vh - 140px)"
      >
        <div v-if="selectedTripId">
          <div v-if="tripTab == 0">
            <OperationTripDetails
              ref="viewTripDetails"
              :trip="{ ...tripDetailsKpi, ...tripDetails }"
            />
          </div>

          <div v-if="tripTab == 1">
            <OperationTripOrders
              ref="tripOrdersList"
              :filters="tripOrderFilter"
            />
          </div>
        </div>
        <div v-else>
          <div v-if="operationTab == 0">
            <OperationDriverLocations
              ref="driverLocations"
              :filters="driverLocationFilter"
              :tabs="operationTab"
            />
          </div>

          <div v-if="operationTab == 1" class="pt-1 background_color">
            <OperationTripSummary
              ref="operationTripSummary"
              :filters="tripSummaryFilter"
              :tabs="operationTab"
            />
          </div>

          <div v-if="operationTab == 2">
            <OperationOrders
              ref="operationTripOrders"
              :filters="orderFilter"
              :tabs="operationTab"
            />
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import {
  operationalAnalyticsModule,
  orderModule,
  tripModule,
  fleetModule,
  itemModule,
} from "@/utils/moduleMapping";
import TripAndDriverList from "@/components/ModuleBasedComponents/Operation/TripAndDriverList.vue";
import OperationDriverLocations from "@/components/ModuleBasedComponents/Operation/OperationDriverLocations.vue";
import OperationTripSummary from "@/components/ModuleBasedComponents/Operation/OperationTripSummary.vue";
import OperationOrders from "@/components/ModuleBasedComponents/Operation/OperationOrders.vue";
import OperationTripOrders from "@/components/ModuleBasedComponents/Operation/OperationTripOrders.vue";
import OperationTripDetails from "@/components/ModuleBasedComponents/Operation/OperationTripDetails.vue";
import { returnToday } from "@/utils/functions";

export default {
  components: {
    TripAndDriverList,
    OperationTripDetails,
    OperationDriverLocations,
    OperationTripSummary,
    OperationOrders,
    OperationTripOrders,
  },

  data() {
    return {
      operationalAnalyticsModule,
      orderModule,
      tripModule,
      fleetModule,
      itemModule,
      order: {},
      operationTab: 0,
      tripTab: 0,
      date: returnToday(),
      nowDate: returnToday(),
      tripCount: {},
      tripDetails: {},
      tripDetailsKpi: {},
      selectedTripId: null,
      selectedTripBranchId: null,
      selectedTripDetails: {},
      allProjects: [],
      selectedProject: null,
      tripOrderFilter: {},
      driverLocationFilter: {
        date: returnToday(),
      },
      orderFilter: {
        date: returnToday(),
      },
      tripListFilter: {
        date: returnToday(),
      },
      tripSummaryFilter: {
        date: returnToday(),
      },
      projectList: [],
    };
  },

  computed: {
    isCurrentTabsVisible() {
      return this.nowDate && this.date && this.nowDate != this.date
        ? false
        : true;
    },
  },

  watch: {
    tripTab(val) {
      if (val == 0) {
        this.getTripDetails();
        this.getTripKpi();
        let timer = setInterval(() => {
          if (this.$refs.viewTripDetails) {
            clearInterval(timer);
            this.$refs.viewTripDetails.getSelectedTripDetails();

            this.$refs.viewTripDetails.openChatBox();
          }
        }, 100);
        setTimeout(() => {
          clearInterval(timer);
        }, 1000);
      } else if (val == 1) {
        setTimeout(() => {
          if (this.$refs.tripOrdersList) {
            this.tripOrderFilter.date = this.date;
            this.tripOrderFilter.trip = this.selectedTripId;
            this.$refs.tripOrdersList.getOrderList();
          }
        }, 200);
      }
    },
    isCurrentTabsVisible(val) {
      if (val) {
        this.operationTab = 0;
      }
    },
    date(val) {
      this.selectedTripId = null;
      this.orderFilter.date = this.date;
      this.tripListFilter.date = val;
      this.tripSummaryFilter.date = val;
      if (this.nowDate != val) {
        let timer = setInterval(() => {
          if (this.$refs.operationTripOrders) {
            clearInterval(timer);
            this.orderFilter.date = this.date;
            this.$refs.operationTripOrders.getTripAnalytics();
            this.$refs.operationTripOrders.itemsPerPageChange(10);
          }
        }, 200);
        setTimeout(() => {
          clearInterval(timer);
        }, 1000);
      }
    },
  },
  methods: {
    // onProjectChange() {

    //   if (this.selectedProject) {
    //     this.driverLocationFilter.project = this.selectedProject;
    //     this.orderFilter.project = this.selectedProject;
    //     this.tripSummaryFilter.project = this.selectedProject;

    //     this.tripListFilter = {
    //       project: this.selectedProject,
    //       ...this.tripListFilter,
    //     };
    //   } else {
    //     delete this.driverLocationFilter.project;
    //     delete this.orderFilter.project;
    //     delete this.tripSummaryFilter.project;
    //     delete this.tripListFilter.project;
    //     this.tripListFilter = {
    //       ...this.tripListFilter,
    //     };
    //     this.operationTab = 0;
    //     this.$refs.driverLocations.getMapInfo({ date: this.date });
    //   }
    // },
    // getProjectList() {
    //   this.$api.project
    //     .getProjectList({ limit: "all" })
    //     .then((res) => {
    //       console.log(res.data);
    //       this.projectList = res.data;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    onSetToday() {
      this.selectedTripId = null;
      this.operationTab = 2;
      this.date = this.nowDate;
    },
    previousDay() {
      this.operationTab = 2;
      let newEnd = new Date(this.date);
      newEnd.setDate(newEnd.getDate() - 1);
      this.date = newEnd.toISOString().slice(0, 10);
    },
    nextDay() {
      this.operationTab = 2;
      let newEnd = new Date(this.date);
      newEnd.setDate(newEnd.getDate() + 1);
      this.date = newEnd.toISOString().slice(0, 10);
    },
    async selectedTripChanged(data) {
      this.selectedTripBranchId = data.branch_id;
      if (this.selectedTripId == data.id) {
        this.selectedTripId = null;
        this.operationTab = 2;
        this.selectedTripDetails = {};
      } else {
        this.tripTab = 0;
        this.selectedTripDetails = data;
        this.selectedTripId = data.id;
        Promise.all([this.getTripDetails(), this.getTripKpi()]).then(() => {
          let timer = setInterval(() => {
            if (this.$refs.viewTripDetails) {
              clearInterval(timer);
              this.$refs.viewTripDetails.getSelectedTripDetails();
              this.$refs.viewTripDetails.openChatBox();
            }
          }, 100);
          setTimeout(() => {
            clearInterval(timer);
          }, 1000);
        });
      }
    },
    async getTripDetails() {
      bus.$emit("showLoader", true);
      let payload = {
        branch: this.selectedTripBranchId,
      };
      await this.$api.trip
        .getTripDetails(this.selectedTripId, payload)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tripDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getTripKpi() {
      bus.$emit("showLoader", true);
      await this.$api.newOperation
        .getTripKpi(this.selectedTripId)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tripDetailsKpi = res.data;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    // this.getProjectList();
  },
};
</script>

<style>
.app-operations-layout .app-operations-layout-list .v-item-group {
  height: 35px;
}
.app-operations-layout {
  display: grid;
  grid-template-columns: 350px 1fr;
  height: calc(100vh - 65px);
}
</style>
